import { render } from "./SalesPricePlantsList.vue?vue&type=template&id=e3be5450&scoped=true&ts=true"
import script from "./SalesPricePlantsList.vue?vue&type=script&lang=ts"
export * from "./SalesPricePlantsList.vue?vue&type=script&lang=ts"

import "./SalesPricePlantsList.vue?vue&type=style&index=0&id=e3be5450&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3be5450"]])

export default __exports__